<template>
  <nav v-if="client" class="breadcrumb" aria-label="breadcrumbs">
    <ul>
      <li><router-link to="/">{{client.name}}</router-link></li>
      <li v-for="b in breadcrumbs" :class="{'is-active':b.isActive || b.notClickable}">
        <router-link v-if="b.lname" :to="{ name: b.routeName }">{{ `breadcrumbs.${b.lname}` | translate }}</router-link>
        <router-link v-if="b.dynamic" :to="{ name: b.routeName }">{{ getDynamicBreadcrumb(b.dynamic) }}</router-link>
      </li>
    </ul>
  </nav>
</template>
<script>
  import breadcrumbsService from '../services/breadcrumbs.service'
  import state from '../state'

  export default {
    name: 'breadcrumbs',
    computed: {
      client() {
        return state.client.get();
      },
      breadcrumbs() {
        return this.getBreadcrumbs();
      }
    },
    methods: {
      getBreadcrumbs() {
        let br = [];
        this.$route.matched.forEach(r => {
          if (r.meta.breadcrumb) {
            br.push({
              routeName: r.meta.breadcrumb.routeName,
              lname: r.meta.breadcrumb.lname,
              dynamic: r.meta.breadcrumb.dynamic,
              notClickable: r.meta.breadcrumb.notClickable
            });
          }
        });
        if (br.length) {
          br[br.length - 1].isActive = true;
        }
        return br;
      },
      getDynamicBreadcrumb(key) {
        let breadcrumb = false;
        breadcrumbsService.dynamic.getAll().forEach(b => {
          if (b.key === key) {
            breadcrumb = b;
          }
        });
        if (!breadcrumb || !breadcrumb.func) {
          console.warn(`[dynamic breadcrumb not found for key ${key}]`);
        }
        let message = '...';
        try {
          message = breadcrumb.func();
        } catch(err) {
          console.warn(`[dynamic breadcrumb error for key ${key}: ${err}]`);
        }
        return message;
      }
    }
  };
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/breadcrumbs.vue